// ============================================================
//  CONFIG CLIENT — seul fichier à modifier par déploiement
// ============================================================

const config = {

  // --- IDENTITÉ ---
  clientName:  "Ehv",     // ex: "Bazin"
  clientShort: "EHV",    // ex: "BZN" (sidebar repliée)

  // --- COULEURS ---
  primaryColor: "#2f7198",
  accentColor:  "#56a537",

  // --- API ---
  apiBase: "https://ehv.ams-crm.fr/api",            // ex: "https://bazin.ams-crm.fr/api"

  // --- AUTH ---
  // Clés utilisées dans localStorage
  tokenKey: "ehv_token",          // ex: "authToken"
  userKey:  "ehv_user",           // ex: "adminUser"
  // Champ login renvoyé par l'API dans data.user
  loginField: "username",      // ex: "username" ou "login"

  // --- ROUTE PAR DÉFAUT APRÈS LOGIN ---
  defaultRoute: "/planning",  // ex: "/planning"

  // --- APPS ---
  // Ajoute / supprime selon le client
  apps: [
    { key: "clients",  label: "Clients",     icon: "👥", url: "https://kanban.ehv.ams-crm.fr/?clients=1", permission: "can_access_kanban", pinned: true },
    { key: "kanban",   label: "Production", icon: "🧾", url: "https://kanban.ehv.ams-crm.fr", permission: "can_access_kanban" },
    { key: "moe", label: "Kanban MOE", icon: "🚧", url: "https://kanban.ehv.ams-crm.fr/?works=1", permission: "can_access_kanban" },
    { key: "facturation", label: "Facturation", icon: "💶", url: "https://kanban.ehv.ams-crm.fr/facturation.php", permission: "can_view_finance" },
    { key: "suivi-facturation", label: "Suivi facturation", icon: "📊", permission: "can_view_finance", pinned: true },
    { key: "fiches",   label: "Fiches terrain", icon: "✍️", url: "https://fiches.ehv.ams-crm.fr", permission: "can_access_fiches" },
    { key: "planning", label: "Planning production", icon: "📅", url: "https://planning.ehv.ams-crm.fr", permission: "can_access_planning" },
    { key: "planning-moe", label: "Planning MOE", icon: "📅", url: "https://planning.ehv.ams-crm.fr/?mode=moe", permission: "can_access_planning" },
   
  ]

};

export default config;